import React, { useEffect, useState } from "react";
import axios from "axios";

const INDUSTRY_IMAGES = {
  'Information Technology': '/images/industry/information-technology.png',
  'Automotive': '/images/industry/automotive.png',
  'Banking, Financial Services & Insurance (BFSI)': '/images/industry/bfsi.png',
  'NBFC & Fintech': '/images/industry/nbfc-fintech.png',
  'FMCG & Consumer Goods': '/images/industry/fmcg-consumer-goods.png',
  'Manufacturing & Industrial': '/images/industry/manufacturing-industrial.png',
  'Retail & E-Commerce': '/images/industry/retail-ecommerce.png',
  'Pharmaceutical & Healthcare': '/images/industry/pharmaceutical-healthcare.png',
  'Logistics & Supply Chain': '/images/industry/logistics-supply-chain.png',
  'Construction & Real Estate': '/images/industry/construction-real-estate.png',
  'Telecom & Telecommunications': '/images/industry/telecom-telecommunications.png',
  'Hospitality & Services': '/images/industry/hospitality-services.png',
};

const IndustriesPage = ({ url }) => {
  const [categories, setCategories] = useState([]);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchList = async () => {
    try {
      const res = await axios.get(`${url}/api/industry/list`);
      if (res.data && res.data.success) setCategories(res.data.data || []);
      else {
        console.error("Fetch error:", res.data);
        alert("Error fetching industries");
      }
    } catch (err) {
      console.error("Axios error:", err);
      alert("Network or server error");
    }
  };

  const toggle = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  return (
    <div className="yo-container" id="industries">
      <style jsx="true">{`
        @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap");

        .yo-container {
          font-family: "Inter", sans-serif;
          background-color: #e6e6fa;
          padding: 2rem;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .yo-header {
          max-width: 1400px;
          width: 95%;
          margin-bottom: 2rem;
          text-align: center;
        }

        .yo-section-label {
          font-size: 2.5rem;
          font-weight: 700;
          color: #333;
          text-align: center;
          margin: 40px 0 20px;
          letter-spacing: 1px;
          position: relative;
        }

        .yo-section-label::after {
          content: "";
          width: 80px;
          height: 4px;
          background: #006AB0;
          display: block;
          margin: 10px auto 0;
          border-radius: 2px;
        }

        .yo-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1rem;
          width: 95%;
          max-width: 1400px;
          margin: 0 auto;
          min-width: 320px;
          align-items: start;
        }

        .yo-card {
          background: #fff;
          border: 1px solid #e8e8ee;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(20, 20, 50, 0.04);
          overflow: hidden;
          transition: transform 0.18s ease, box-shadow 0.18s ease;
          display: flex;
          flex-direction: column;
          min-height: 0;
        }

        .yo-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 22px rgba(20, 20, 50, 0.07);
        }

        .yo-card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.85rem 1rem;
          cursor: pointer;
          font-weight: 600;
          color: #333;
          flex-shrink: 0;
        }

        .yo-toggle {
          font-size: 1.2rem;
        }

        .yo-card-content {
          overflow: hidden;
          max-height: 0;
          transition: max-height 0.45s ease, padding 0.25s ease;
          padding: 0 1rem;
          flex: 1;
        }

        .yo-card.expanded .yo-card-content {
          max-height: 2000px;
          padding: 1rem;
        }

        .yo-card-image {
          width: 100%;
          height: 180px;
          object-fit: cover;
          border-radius: 6px;
          margin-bottom: 1rem;
        }

        .yo-desc {
          margin: 0 0 1rem 0;
          color: #555;
          line-height: 1.5;
          font-size: 0.95rem;
        }

        .yo-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .yo-list li {
          display: flex;
          align-items: center;
          margin-bottom: 0.5rem;
          color: #444;
          font-size: 0.95rem;
        }

        .yo-list li::before {
          content: "✔";
          margin-right: 0.6rem;
          color: #007bff;
          font-size: 1.05rem;
        }

        @media (max-width: 768px) {
          .yo-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="yo-header">
        <p className="yo-section-label">Industries we work with</p>
      </div>

      <div className="yo-grid">
        {categories.map((category, i) => {
          const id = `industry-${i}`;
          const list = category.list ?? [];
          const imageSrc = INDUSTRY_IMAGES[category.name] || (category.image?.startsWith('industry/') ? `/images/${category.image}` : category.image ? `${url}/images/${category.image}` : null);
          const isExpanded = expandedId === id;
          return (
            <div
              className={`yo-card ${isExpanded ? "expanded" : ""}`}
              key={id}
            >
              <div className="yo-card-header" onClick={() => toggle(id)}>
                <span>{category.name}</span>
                <span className="yo-toggle">
                  {isExpanded ? "−" : "+"}
                </span>
              </div>

              {category.description && (
                <div className="yo-card-content">
                  {imageSrc && (
                    <img src={imageSrc} alt={category.name} className="yo-card-image" />
                  )}
                  <p className="yo-desc">{category.description}</p>
                  <ul className="yo-list">
                    {list.map((li, idx) => (
                      <li key={idx}>{li}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IndustriesPage;
